export default __webpack_public_path__ + "static/media/nombre-app.2e529c24.svg";